import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { formatApiError } from "../lib/apiClient";

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=checking, object=logged, false=not logged
  const [error, setError] = useState(null);

  const checkSession = useCallback(async () => {
    try {
      const { data } = await api.get("/admin/me");
      setUser(data);
    } catch (e) {
      if (e?.response?.status === 401) {
        // Try refresh
        try {
          const { data } = await api.post("/admin/refresh");
          setUser(data);
          return;
        } catch {
          // ignore
        }
      }
      setUser(false);
    }
  }, []);

  useEffect(() => {
    checkSession();
  }, [checkSession]);

  const login = async (email, password) => {
    setError(null);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      if (data?.access_token) {
        localStorage.setItem("admin_access_token", data.access_token);
      }
      setUser({ email: data.email, role: data.role });
      return true;
    } catch (e) {
      setError(formatApiError(e));
      return false;
    }
  };

  const logout = async () => {
    try {
      await api.post("/admin/logout");
    } catch {
      // ignore
    }
    localStorage.removeItem("admin_access_token");
    setUser(false);
  };

  return (
    <AdminAuthContext.Provider value={{ user, error, login, logout, checkSession }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminAuthContext);
